module.exports = __webpack_public_path__ + "static/media/deleteIcon.b885f904.svg";